import React from 'react';
import { connect } from 'umi';
import classnames from 'classnames';
import { get, head, isEmpty } from 'lodash';
import { Text } from '@digitalc/dxp-ui';
import useGCPI18n from '@/hooks/useGCPI18n';
import { Clickable } from '@/components';
import { getThemeImgByKey, onHistoryPush } from '@/utils/utils';
import { trackSensors } from '@/utils/sensors';
import styles from './index.less';

const DataOffers = props => {
  const GCPI18n = useGCPI18n();
  const dataOfferList = get(props, 'dataOfferList');
  // const pointAccountsInfo = get(props, 'pointAccountsInfo');
  const dxpToken = get(props, 'dxpToken');
  const isWeb = get(props, 'isWeb');
  const isMulPoints = get(props, 'isMulPoints');
  const catgctName = get(props, 'catgctName');
  // const entrancePage = get(props, 'entrancePage');

  const openDetails = offerItem => {
    // history.push({
    //   pathname: '/pointshop/details',
    //   state: { productListitem: offerItem, entrancePage },
    // });
    trackSensors('reward_listing', {
      category: catgctName,
      action: 'button_click',
      label: 'cta',
      section: 'rewards',
      product_name: offerItem?.name || '',
      productskuid: get(head(get(offerItem, 'skuList')), 'skuCode') || '',
    });

    let path = `/pointshop/details/${offerItem.id}`;
    if (isWeb) {
      path = path.replace('/details', '/pointsH5/modal/details');
    }
    onHistoryPush(path, {
      pointAcctTypeCode: get(head(get(offerItem, 'skuList')), 'pointAcctTypeCode'),
      category: catgctName,
    });
    // history.push({
    //   pathname: path,
    //   query: {
    //     pointAcctTypeCode: get(head(get(offerItem, 'skuList')), 'pointAcctTypeCode'),
    //   },
    // });
  };

  const renderOfferItem = (dataOfferListItem, index) => {
    const skuList = get(dataOfferListItem, 'skuList');
    if (isEmpty(skuList)) return null;

    if (skuList.length > 1000) {
      return (
        <Clickable
          className={styles.OfferListItem}
          key={get(dataOfferListItem, 'id') + index}
          onClick={() => {
            openDetails(dataOfferListItem);
          }}
        >
          {/* {get(dataOfferListItem, 'isNew') === 'Y' && <img className={styles.newIcon} src={newIcon} alt="" />} */}
          <img
            className={styles.offerImg}
            src={get(head(skuList), 'thumbImage')}
            alt=""
          />
          <div className={styles.offerDetail}>
            <p className={styles.offerSize}>{get(dataOfferListItem, 'name')}</p>
            {/* <p
              className={styles.offerTime}
              dangerouslySetInnerHTML={{ __html: get(head(skuList), 'brief') }}
            /> */}
            <p className={styles.PackSpecs}>
              {skuList.map(packSpecsItem => (
                <span key={get(packSpecsItem, 'skuId')} className={styles.packSpecsItem}>
                  {get(packSpecsItem, 'name')}
                </span>
              ))}
            </p>
          </div>
        </Clickable>
      );
    }

    return (
      <Clickable
        className={styles.OfferListItem}
        key={get(dataOfferListItem, 'id') + index}
        onClick={() => {
          openDetails(dataOfferListItem);
        }}
        style={{ borderRadius: dxpToken.borderRadiusSm }}
      >
        {/* {get(dataOfferListItem, 'isNew') === 'Y' && <img className={styles.newIcon} src={newIcon} alt="" />} */}
        <img
          className={styles.offerImg}
          src={get(head(skuList), 'thumbImage') || getThemeImgByKey('offerDefThumbnail')}
          alt=""
        />
        <div className={styles.offerDetail}>
          {/* <p className={styles.offerSize}>{get(dataOfferListItem, 'name')}</p> */}
          <Text
            style={{ color: dxpToken.colorTextNeutral }}
            breakpoint="Mobile"
            size="ContentC12Bold"
            className={styles.offerName}
          >
            {get(dataOfferListItem, 'name')}
          </Text>
          {/* <p
            className={styles.offerTime}
            dangerouslySetInnerHTML={{ __html: get(head(skuList), 'brief') }}
          /> */}

          <div className={styles.pointWrap}>
            <Text
              style={{ color: dxpToken.colorTextNeutral }}
              breakpoint="Mobile"
              size="ContentC12Regular"
            >
              {`${get(head(skuList), 'pointPriceDisplay') || 0} ${GCPI18n({
                id: 'lb_data_offers_points',
              })}`}
            </Text>
            {isMulPoints && get(head(skuList), 'pointAcctTypeName') && (
              <div
                className={styles.pointAcctName}
                style={{ background: dxpToken.colorTagGreyLight }}
              >
                <Text
                  breakpoint="Mobile"
                  size="ContentC12Bold"
                  style={{ color: dxpToken.colortagblack }}
                >
                  {get(head(skuList), 'pointAcctTypeName') || ''}
                </Text>
              </div>
            )}
          </div>
          {/* <p className={styles.offerPoint}>
            <span>{get(head(skuList), 'pointPriceDisplay') || 0}</span>{' '}
            {intl.GCPI18n({
              id: 'DITO_DATA_OFFERS_POINTS',
            })}
          </p> */}
          {/* <div className={styles.pointAcctName}>{get(head(skuList), 'pointAcctTypeName') || ''}</div> */}
          {/* <Tag types="grey" rounded light>{get(head(skuList), 'pointAcctTypeName') || ''}</Tag> */}
        </div>
      </Clickable>
    );
  };

  return (
    <div
      className={classnames(styles.offerList, isWeb && styles.webOfferList)}
      // style={isEmpty(catgctList) && !path ? { height: 'calc( 100vh - 1.44rem)' } : null}
    >
      <div className={styles.DataOffersList}>
        {!isEmpty(dataOfferList) && dataOfferList.map(renderOfferItem)}
      </div>
    </div>
  );
};

export default connect()(DataOffers);
